<h1>Our great leaders</h1>
Here rest all past Leaders of the Website. May they achieve here the peace they were forbidden during their service. Let
all remember the glory they brought to the Website.
<hr>
<div class="temple">
    <mat-card class="timeline-card">
        <mat-card-header>
            <mat-card-title>Giovanni "Creator"</mat-card-title>
            <mat-card-subtitle>(Feb. 2021 - Oct. 2023)</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <p>
                The Founder of the Website, Forger of Components and alliances.
                <br>
                Deified after his disappearance, the Cult counts thousands.
            </p>
        </mat-card-content>
    </mat-card>

    <mat-card class="timeline-card">
        <mat-card-header>
            <mat-card-title>Daniele "Expugnator"</mat-card-title>
            <mat-card-subtitle>(Oct. 2023 - Apr. 2024)</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <p>
                Expanded the power of the Website and its tax system.
                <br>
                Third TypeScript war: conquered and submitted TypeScript.
            </p>
        </mat-card-content>
    </mat-card>

    <mat-card class="timeline-card">
        <mat-card-header>
            <mat-card-title>Leonardo "Restaurator"</mat-card-title>
            <mat-card-subtitle>(Apr. 2024 - )</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <p>
                Restauratio Imperii: reformed bureaucracy and reorganised military, bringing a new era of prosperity.
            </p>
        </mat-card-content>
    </mat-card>
</div>